export const cooperationType = {
  single: 1,
  frame: 2
}

export const templateType = {
  me: 1,
  other: 2
}

export const checkFlagType = {
  review: 1,
  deni: 2,
  pass: 3
}

export const contractTypeDirection = {
	out: 1,
	in: 2,
}

export const payType = {
	out: 1,
	in: 2,
}

export const stampOrder = {
	me: 1,
	other: 2,
}

export const cooperationTypeName = (key) => {
  switch (key) {
    case cooperationType.single:
      return '单笔'
    case cooperationType.frame:
      return '框架'
    default:
      return ''
  }
}

export const checkFlagTypeName = (key) => {
  switch (key) {
    case checkFlagType.review:
      return '审核中'
    case checkFlagType.deni:
      return '审核不通过'
    case checkFlagType.pass:
      return '审核通过'
    default:
      return ''
  }
}

export const templateTypeName = (key) => {
  switch (key) {
    case templateType.me:
      return '我方模板'
    case templateType.other:
      return '对方模板'
    default:
      return ''
  }
}

export const contractTypeDirectionName = (key) => {
	switch (key) {
		case contractTypeDirection.in:
			return '收款'
		case contractTypeDirection.out:
			return '付款'
		default:
			return ''
	}
}

export const payTypeName = (key) => {
	switch (key) {
		case templateType.me:
			return '预付'
		case templateType.other:
			return '后付'
		default:
			return ''
	}
}

export const stampOrderName = (key) => {
	switch (key) {
		case stampOrder.me:
			return '我方先盖章'
		case stampOrder.other:
			return '对方先盖章'
		default:
			return ''
	}
}


// WEBPACK FOOTER //
// ./src/config/workflow/contract.js